import z from "zod";

const puppeteerErrorTypeValues = [
  "GLOBAL_APP_SETTING_NOT_FOUND",
  "PAGE_CREATION_FAILED",
  "TOO_MANY_REDIRECTS",
] as const;

const puppeteerErrorTypeSchema = z.enum(puppeteerErrorTypeValues);
const PuppeteerErrorType = puppeteerErrorTypeSchema.enum;
type PuppeteerErrorType = z.infer<typeof puppeteerErrorTypeSchema>;

export type PuppeteerErrors =
  | {
      errorType: typeof PuppeteerErrorType.GLOBAL_APP_SETTING_NOT_FOUND;
      data: { settingKey: string; messageType?: string };
    }
  | { errorType: typeof PuppeteerErrorType.PAGE_CREATION_FAILED; data: { action: string; targetUrl?: string } }
  | { errorType: typeof PuppeteerErrorType.TOO_MANY_REDIRECTS; data: { url: string; maxRedirects: number } };

export const puppeteerErrorDetails: Record<PuppeteerErrorType, { sentryDescription: string }> = {
  TOO_MANY_REDIRECTS: { sentryDescription: "Too many redirects encountered during Puppeteer operation" },
  GLOBAL_APP_SETTING_NOT_FOUND: { sentryDescription: "Required global app setting not found for Puppeteer operation" },
  PAGE_CREATION_FAILED: { sentryDescription: "Failed to create new page from Puppeteer browser action" },
};
